import styled from '@emotion/styled';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  display,
  DisplayProps,
  flexbox,
  FlexboxProps,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  ShadowProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  shouldForwardProp,
  WithoutCollidingProps,
} from '../../theming';

export interface BaseHeadingProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    FlexboxProps,
    GridProps,
    LayoutProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TypographyProps {}

type NonCollidingHeadingProps = WithoutCollidingProps<BaseHeadingProps, 'h1'>;
type NonCollidingHeadingKeys = keyof NonCollidingHeadingProps;

export const Heading = styled('h1', {
  shouldForwardProp: (prop): prop is NonCollidingHeadingKeys =>
    shouldForwardProp(prop as NonCollidingHeadingKeys),
})<BaseHeadingProps>(
  defineWithTheme('headings'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    space,
    typography
  )
);

export type HeadingProps = React.ComponentPropsWithoutRef<typeof Heading>;
